import { render, staticRenderFns } from "./RegistrationCompletedView.vue?vue&type=template&id=7c11fa5a&scoped=true&"
import script from "./RegistrationCompletedView.vue?vue&type=script&lang=js&"
export * from "./RegistrationCompletedView.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCompletedView.vue?vue&type=style&index=0&id=7c11fa5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c11fa5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VApp,VContainer,VLayout})
